import { useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2, Send, FlaskConical } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const NewsEmailButton = ({ version }) => {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try { setD((await api.post(`/admin/releases/${version}/news-preview`)).data); } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  const test = async () => {
    setBusy(true);
    try { toast.success(t("news.test_sent").replace("{e}", (await api.post(`/admin/releases/${version}/news-test`)).data.to)); } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  const send = async () => {
    if (!window.confirm(t("news.confirm").replace("{n}", d.recipients))) return;
    setBusy(true);
    try {
      const r = await api.post(`/admin/releases/${version}/news-send`);
      toast.success(t("news.sent").replace("{n}", r.data.queued));
      setD({ ...d, sent_at: new Date().toISOString() });
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <>
      <button data-testid={`admin-release-email-${version}`} onClick={open} title={t("news.btn")} className="p-2 text-slate-400 hover:text-[#3ad7ff]">
        {busy && !d ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />}
      </button>
      <Dialog open={!!d} onOpenChange={(o) => !o && setD(null)}>
        <DialogContent className="bg-[#0b0e1a] border-white/10 max-w-2xl" data-testid="news-email-dialog">
          <DialogHeader><DialogTitle className="text-white">{t("news.title")} · V{version}</DialogTitle></DialogHeader>
          {d && <>
            <div className="text-xs text-slate-400" data-testid="news-email-subject">{t("news.subject")} : <span className="text-slate-200">{d.subject}</span></div>
            <iframe title="preview" srcDoc={d.html} className="w-full h-[420px] rounded-lg border border-white/10 bg-[#05060d]" data-testid="news-email-preview" />
            <div className="flex items-center justify-between gap-3">
              <span className="text-xs text-slate-400" data-testid="news-email-recipients">{d.sent_at ? t("news.already") : t("news.recipients").replace("{n}", d.recipients)}</span>
              <div className="flex gap-2">
                <button onClick={test} disabled={busy} data-testid="news-email-test"
                  className="rounded-full px-4 py-2.5 text-sm font-semibold inline-flex items-center gap-2 border border-white/15 text-slate-200 hover:border-[#3ad7ff] disabled:opacity-50">
                  <FlaskConical className="w-4 h-4" />{t("news.test")}
                </button>
                <button onClick={send} disabled={busy || !!d.sent_at} data-testid="news-email-send"
                  className="cx-btn rounded-full px-5 py-2.5 text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-50">
                  {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}{t("news.send")}
                </button>
              </div>
            </div>
          </>}
        </DialogContent>
      </Dialog>
    </>
  );
};
